import React from "react";
import "./styles.css";

const Card = ({ children, className, ...props }) => {
  return (
    <div className={`table-card ${className}`} {...props}>
      {children}
    </div>
  );
};

export default Card;
